export default __webpack_public_path__ + "static/media/biofit-builder-series-GX.65a51437.png";